
import { Routes, Route} from 'react-router-dom';
import Home from './pages/home.js';
import NotFound from './pages/notFound.js';
import Projects from './pages/projects.js';
import ReportBug from './pages/contactus.js'
import UnderConstruction from './pages/underConstruction.js';
import './App.css';

function App() {
  return (
  
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/not_found" element={<NotFound/>} />
      <Route path="/resources" element={<UnderConstruction />} />
      <Route path="/add_projects" element={<UnderConstruction />} />
      <Route path="/resources" element={<UnderConstruction />} />
      <Route path="/resources" element={<UnderConstruction />} />
      <Route path="/report_bug" element={<ReportBug/>} />
      <Route path="*" element={<NotFound/>} />
    </Routes>
  );
}

export default App;
